import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon, { IconSizes, IconTypes } from '../../components/foundations/Icon';
import css from './ChatInput.css';

const ChatInput = memo(
    ({ input, handleInputChange, handleSubmit, isLoading, stop, onMicClick, containerClassName }) => {
        const handleKeyDown = e => {
            // Submit on Enter (without Shift)
            if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                handleSubmit(e);
            }
        };

        const handleFormSubmit = e => {
            e.preventDefault();
            if (input.trim() && !isLoading) {
                handleSubmit(e);
            }
        };

        return (
            <div className={classNames(css.chatInputContainer, containerClassName)}>
                <form onSubmit={handleFormSubmit} className={css.chatInputForm}>
                    <div className={css.inputContainer}>
                        <div className={css.inputHeader}>
                            <input
                                type="text"
                                className={css.inputField}
                                placeholder={isLoading ? 'AI is responding...' : 'Ask me about your reporting data...'}
                                value={input}
                                onChange={handleInputChange}
                                onKeyDown={handleKeyDown}
                                disabled={isLoading}
                            />
                            <div className={css.inputHeaderIcons}>
                                <button
                                    type="button"
                                    className={css.iconButton}
                                    onClick={onMicClick}
                                    disabled={isLoading}
                                    aria-label="Microphone"
                                >
                                    <Icon name="mic-line" type="mingcute" size={IconSizes.SMALL} />
                                </button>
                                {isLoading ? (
                                    <button
                                        type="button"
                                        className={classNames(css.iconButton, css.sendButton)}
                                        onClick={stop}
                                        aria-label="Stop"
                                    >
                                        <Icon name="square" type={IconTypes.TABLER} size={IconSizes.SMALL} />
                                    </button>
                                ) : (
                                    <button
                                        type="submit"
                                        disabled={!input.trim() || isLoading}
                                        className={classNames(css.iconButton, css.sendButton)}
                                        aria-label="Send"
                                    >
                                        <Icon name="arrow-up-fill" type="mingcute" size={IconSizes.SMALL} />
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
);

ChatInput.propTypes = {
    input: PropTypes.string.isRequired,
    handleInputChange: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    stop: PropTypes.func.isRequired,
    onMicClick: PropTypes.func,
    containerClassName: PropTypes.string,
};

export default ChatInput;
